module.exports = __webpack_public_path__ + "img/qr_code_dispojob.d49032cf.png";